module.exports = __webpack_public_path__ + "static/media/sala_espera.61a15136.png";